export interface StarterPageCloseModalAction {
  type: 'STARTER_PAGE_CLOSE_MODAL';
}
export const STARTER_PAGE_CLOSE_MODAL = 'STARTER_PAGE_CLOSE_MODAL';

export interface StarterPageVideoPlayAction {
  type: 'STARTER_PAGE_VIDEO_PLAY';
  autoplay: boolean;
}
export const STARTER_PAGE_VIDEO_PLAY = 'STARTER_PAGE_VIDEO_PLAY';

export interface StarterPageVideoEndAction {
  type: 'STARTER_PAGE_VIDEO_END';
}
export const STARTER_PAGE_VIDEO_END = 'STARTER_PAGE_VIDEO_END';

export interface StarterPageVideoPassTimestampAction {
  type: 'STARTER_PAGE_VIDEO_PASS_TIMESTAMP';
  timestamp: number;
}
export const STARTER_PAGE_VIDEO_PASS_TIMESTAMP =
  'STARTER_PAGE_VIDEO_PASS_TIMESTAMP';

export type StarterPageAction =
  | StarterPageCloseModalAction
  | StarterPageVideoPlayAction
  | StarterPageVideoEndAction
  | StarterPageVideoPassTimestampAction;
